import { render } from "./AddonTags.vue?vue&type=template&id=5d181c9e&scoped=true"
import script from "./AddonTags.vue?vue&type=script&lang=js"
export * from "./AddonTags.vue?vue&type=script&lang=js"

import "./AddonTags.vue?vue&type=style&index=0&id=5d181c9e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d181c9e"]])

export default __exports__